import React from "react";
import {ColoredCustomCardTag, CustomCardTag, ServerTypeCardTag} from "./CustomCardTag";
import {customTagNumberToString, serverTypeToString} from "./function/customClanFunction";
import {useTheme} from "styled-components";
import {MarginBox} from "../ui/styled";

const CustomClanTags = ({value, isColor, isServerType}) => {
    const theme = useTheme();

    if (isServerType) {
        const obj = serverTypeToString(value);
        return (<ServerTypeCardTag>
            <MarginBox margin={'0 2px 0 0'}>
                <img src={`/images/dark/connect/${obj.img}`} width={20} height={20} alt={''}/>
            </MarginBox>
            <div>
                <span>{obj.title}</span>
            </div>
        </ServerTypeCardTag>)
    }

    if (isColor) {
        return (<ColoredCustomCardTag>
           # {customTagNumberToString(value)}
        </ColoredCustomCardTag>)
    }
    return (
        <CustomCardTag>
            # {customTagNumberToString(value)}
        </CustomCardTag>
    )
}
export default CustomClanTags